function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M375 620 c4 -6 -10 -10 -34 -10 -40 0 -41 -1 -41 -35 l0 -35 -50 0 -50 0 0 -180 0 -180 46 0 c42 0 45 -1 33 -17 -12 -15 -12 -16 4 -10 12 5 17 1 17 -13 0 -15 -9 -20 -42 -23 l-43 -4 48 -1 c44 -2 47 0 47 23 0 19 4 23 18 18 15 -6 15 -5 3 10 -12 16 -9 17 38 17 l51 0 0 180 0 180 -55 0 c-54 0 -55 0 -55 30 0 28 3 30 36 30 25 0 33 -3 28 -12 -5 -9 -2 -8 9 1 13 10 15 17 6 27 -13 16 -23 19 -14 4z m35 -165 c0 -62 -4 -81 -22 -105 -12 -17 -27 -30 -34 -30 -7 0 -25 18 -41 40 -32 45 -64 52 -87 18 -15 -21 -16 -17 -16 65 l0 87 100 0 100 0 0 -75z m-106 -105 c31 -46 64 -53 89 -17 15 21 16 17 16 -60 l1 -83 -100 0 -100 0 0 68 c0 70 25 132 54 132 7 0 25 -18 40 -40z"
}));

function SvgFavicon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 54.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon1);
export default __webpack_public_path__ + "static/media/favicon1.a006ff09.svg";
export { ForwardRef as ReactComponent };